import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import BookCta from "./BookCta";
import { SITE } from "../data/site";

const CtaBand = ({ title, text }) => (
  <section data-testid="cta-band" className="bg-navy py-14 sm:py-20 text-white hero-lines">
    <div className="container-site flex flex-col items-start gap-7 lg:flex-row lg:items-center lg:justify-between">
      <div className="max-w-2xl">
        <h2 className="font-serif text-3xl sm:text-4xl font-semibold">
          {title || "Parliamo della tua situazione"}
        </h2>
        <p className="mt-3 text-base leading-relaxed text-slate-300">
          {text ||
            `Ogni caso merita una valutazione attenta. Contatta lo studio a Palermo o prenota un appuntamento: analizzeremo insieme la tua posizione e le possibili forme di tutela.`}
        </p>
      </div>
      <div className="flex flex-wrap gap-3">
        <BookCta testId="cta-band-book-button" />
        <a href={SITE.phoneHref} data-testid="cta-band-call-button" className="btn-outline-light">
          {SITE.phone} <ArrowRight size={15} aria-hidden="true" />
        </a>
      </div>
    </div>
  </section>
);

export default CtaBand;
